<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vii">Acknowledgments</a></h2><a id="page_vii">
<p class="images"><img alt="Image" src="images/f0iii-01.jpg"/></p>
<p class="fmot">I’d like to thank Daphne Tilley, for taking me on a long-distance ride across Snowdon to the Lleyn Peninsula, where I discovered the drovers’ roads and the beginnings of my story. Jenny and David Clifford, for lending me their house. Turkish Airlines, for flying me to Istanbul, where I took a boat across the Bosphorus and saw Florence Nightingale’s room at the Barrack Hospital; Alex Attewell, director of the Florence Nightingale Museum at St. Thomas’s Hospital in London for his advice. Special thanks to Delia.</p>
<p class="fmtx">For love and support, thanks to my late mother, Vicki Sutton; to my sister Caroline; to Sarah, Charlotte, Hugo, Natasha, and Poppy; and, of course, Richard, for patiently reading all those drafts. I owe Kate Shaw a big debt of gratitude for her advice and support, and many thanks to my agent, Clare Alexander, for her professionalism and encouragement.</p>
</a><p><a id="page_vii"></a><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?7d00b651